import { useSelector } from "react-redux"
import { isRtlLang } from "rtl-detect"

const useDirection = () => {
  const currentLanguageCode = useSelector((state) => state.currentLanguageCode)
  return isRtlLang(currentLanguageCode) ? "rtl" : "ltr"
}

export default useDirection
